export class RetrieveABAFiles {
    FileName: string;
    Rows?: number;
    Amount?: number;
}